module.exports = __webpack_public_path__ + "static/shark-636b21c4fdb164794622a98528e910db.gif";